import React from 'react';
import { CONTENTTYPE_TEXT } from '../../../../../constants/api';
import { getAttr } from '../../../../../features/helpers/apiHelpers';
import { SummaryFieldRead } from './summaryField/SummaryFieldRead';
import { SummaryFieldWrite } from './summaryField/SummaryFieldWrite';

const SummaryField = ({
  fieldData,
  onChange,
  isEditMode,
  validationEntity,
}) => {
  const [summaryContent] = fieldData.textContent || [];
  const summaryValue = getAttr(summaryContent, 'textContent');

  const onChangeLocal = (value) => onChange(value, CONTENTTYPE_TEXT);

  if (isEditMode) {
    return (
      <SummaryFieldWrite
        summaryValue={summaryValue}
        onChange={onChangeLocal}
        validationEntity={validationEntity}
      />
    );
  } else {
    return <SummaryFieldRead summaryValue={summaryValue} />;
  }
};

export { SummaryField };
